export default __webpack_public_path__ + "static/media/vid-2.93afa524.mp4";